export { default } from './table.styles';
export * from '@mui/material/Table';
